export const ROUTE_PATH = '/reconciliations-receipt-details/:details_id';

export const FEATURE_NAME = 'reconciliationReceiptBonusDetailsPage';
